import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef1c5250"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu" }
const _hoisted_2 = { class: "menu-item left" }
const _hoisted_3 = { class: "menu-item left" }
const _hoisted_4 = { class: "menu-item left" }
const _hoisted_5 = {
  key: 0,
  class: "menu-item left"
}
const _hoisted_6 = { class: "submenu" }
const _hoisted_7 = { class: "menu-item right" }
const _hoisted_8 = { class: "menu-item" }
const _hoisted_9 = { class: "menu-item right" }
const _hoisted_10 = { class: "menu-item" }
const _hoisted_11 = { class: "menu-item right" }
const _hoisted_12 = { class: "search-form" }
const _hoisted_13 = { class: "search-submit" }

import { reactive, onMounted, ref, nextTick, inject } from "vue";
import Login from "@/components/header/Login.vue";
import { InfoFilled } from "@element-plus/icons-vue";
import { postLogout } from "@/api/functions/home";
import { ElMessage } from "element-plus";
import { Icon } from "@iconify/vue";
import { useI18n } from "vue-i18n";
import { reloadKey } from "@/functions/keys/index";
import { reloadFunction } from "@/functions/utils/CommonUtils";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavMenu',
  setup(__props) {

const dialogVisible = reactive({
  visible: false,
});

const inputKey = ref("");

const reload = inject(reloadKey) as reloadFunction;

const loginStatus = ref(localStorage.getItem("token") != null);

const centerDialogVisible = ref(false);

const { locale } = useI18n();
const changeLang = (lang: string) => {
  locale.value = lang;
  localStorage.setItem("lang", lang);
  reload();
};

const onLogout = async () => {
  await postLogout()
    .then((res) => {
      if (res.data.code !== "0") {
        ElMessage({
          message: res.data.msg,
          showClose: true,
          type: "error",
        });
      }
    })
    .finally(() => {
      localStorage.removeItem("token");
      location.reload();
    });
};

const navContent = ref();

async function orderScroll(scrollHeight: any) {
  await nextTick();

  if (scrollHeight > 0) {
    navContent.value.style.position = "fixed";
  } else {
    navContent.value.style.position = "relative";
  }
}

onMounted(() => {
  window.addEventListener("scroll", () => {
    orderScroll(window.scrollY);
  });
});

return (_ctx: any,_cache: any) => {
  const _component_HomeFilled = _resolveComponent("HomeFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Paperclip = _resolveComponent("Paperclip")!
  const _component_Guide = _resolveComponent("Guide")!
  const _component_MagicStick = _resolveComponent("MagicStick")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_User = _resolveComponent("User")!
  const _component_SwitchButton = _resolveComponent("SwitchButton")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_UserFilled = _resolveComponent("UserFilled")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_Search = _resolveComponent("Search")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", {
      class: "navClass",
      ref_key: "navContent",
      ref: navContent
    }, [
      _createElementVNode("ul", _hoisted_1, [
        _createElementVNode("li", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "menu-item-a"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_HomeFilled)
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("menus.home.name")), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/archive",
            class: "menu-item-a"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Paperclip)
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("menus.archive.name")), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/about",
            class: "menu-item-a"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Guide)
                ]),
                _: 1
              }),
              _createTextVNode(_toDisplayString(_ctx.$t("menus.about.name")), 1)
            ]),
            _: 1
          })
        ]),
        (loginStatus.value)
          ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
              _createVNode(_component_router_link, {
                to: "/edit",
                class: "menu-item-a"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_MagicStick)
                    ]),
                    _: 1
                  }),
                  _createTextVNode(_toDisplayString(_ctx.$t("menus.edit.name")), 1)
                ]),
                _: 1
              }),
              _createElementVNode("ul", _hoisted_6, [
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: "/",
                    class: "submenu-item-a"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("草稿箱")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("li", _hoisted_7, [
          _createVNode(_component_el_dropdown, { "hide-on-click": false }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  (loginStatus.value)
                    ? (_openBlock(), _createBlock(_component_el_dropdown_item, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_popconfirm, {
                            width: "220",
                            "confirm-button-text": "Yes",
                            "cancel-button-text": "No",
                            icon: _unref(InfoFilled),
                            "icon-color": "#626AEF",
                            title: "Are you sure to logout?",
                            onConfirm: onLogout
                          }, {
                            reference: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                plain: "",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (centerDialogVisible.value = true))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_SwitchButton)
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode("Logout ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["icon"])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_el_dropdown_item, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            plain: "",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (dialogVisible.visible = true))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_UserFilled)
                                ]),
                                _: 1
                              }),
                              _createTextVNode("Login ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("li", _hoisted_8, [
                (loginStatus.value)
                  ? (_openBlock(), _createBlock(_component_el_avatar, {
                      key: 0,
                      src: "favicon.ico",
                      size: 16
                    }))
                  : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_User)
                      ]),
                      _: 1
                    }))
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_9, [
          _createVNode(_component_el_dropdown, {
            "hide-on-click": false,
            onCommand: changeLang
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_dropdown_item, { command: "zh" }, {
                    default: _withCtx(() => [
                      _createTextVNode("中文")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_dropdown_item, {
                    command: "ja",
                    divided: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("日本語")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_dropdown_item, {
                    command: "en",
                    divided: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("English")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("li", _hoisted_10, [
                _createVNode(_unref(Icon), { icon: "mdi:google-translate" })
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "keyword",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inputKey).value = $event)),
              class: "search-input",
              placeholder: "站内搜索"
            }, null, 512), [
              [_vModelText, inputKey.value]
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, {
                    class: "menu-item-a",
                    to: {
                  path: '/search',
                  query: { key: inputKey.value },
                }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Search)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ], 512),
    _createVNode(Login, { loginVisible: dialogVisible }, null, 8, ["loginVisible"])
  ], 64))
}
}

})